/**
 * files selection handler for <input> elements.
 * @param {FileList} files files inputed by user through <input>
 * @param {function} callBack callBack function to call with the fileSelectHandler output
 * @param {Array} allowedTypes Array containing strings like '.jpg'
 * @param {Number} fileSizeLimit size in bytes // 1048576 bytes = 1MB
 */

export const fileSelectHandler = async (
  files,
  callBack,
  allowedTypes,
  fileSizeLimit = 2097152
) => {
  /* [...files] is being used below because 'files' is of type FileList
    which don't have iteration methods */
  let sizeLimit = 2097152;
  const filesObjects = await Promise.all(
    [...files].map(file => {
      return new Promise((resolve, reject) => {
        const fileSize = file.size;
        const fileNameParts = file.name.split('.');
        const fileName = fileNameParts[0];
        const fileType = fileNameParts[fileNameParts.length - 1];
        if (!(fileSize && fileSize <= sizeLimit)) {
          reject(-1);
        }
        // else if (allowedTypes && !allowedTypes.includes(fileType)) {
        //   reject(-2);
        // }

        let reader = new FileReader();
        reader.onload = function(event) {
          resolve({
            dataUrl: event.target.result,
            fileType,
            fileName,
            fileSize,
          });
        };
        reader.readAsDataURL(file);
      }).catch(rej => rej);
    })
  );
  return callBack(filesObjects);
};

// s3Blobs -> { fileType, link: dataUrl }
export const makeS3BlobsRenderable = s3Blobs => {
  if (!Array.isArray(s3Blobs)) {
    s3Blobs = [s3Blobs];
  }
  return s3Blobs.map(blob => {
    //res is Uint8Array
    const res = new Uint8Array(blob.Body.data);
    const len = res.byteLength;
    let dataUrl = '';
    for (let i = 0; i < len; i++) {
      dataUrl += String.fromCharCode(res[i]);
    }
    let fileType = dataUrl.slice(0, 20).split('/')[1];
    return {
      fileType,
      dataUrl,
      LastModified: blob && blob.LastModified,
      id: blob && blob.id,
    };
  });
};
